import { Button, Space, Form, notification, Tabs, Card, Row, Col, Divider, Descriptions, Radio, Select, Checkbox, } from "antd";
import style from "./index.module.scss";
import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useMemo, useState } from "react";
import boxApi from "api/box";
import TableSushiBox from "./components/TableSushiBox";
import { MAKI_BOX } from "constants/";
import { CALI_BOX } from "constants/";
import { FUTO_BOX } from "constants/";
import { SM_BOX } from "constants/";
import { LG_BOX } from "constants/";
import { MD_BOX } from "constants/";
import { NIGIRI_BOX } from "constants/";
import { ORDER_BOX } from "constants/";
import sushiApi from "api/sushi";
import { CloseOutlined, EditOutlined, ExportOutlined, EyeInvisibleOutlined, EyeOutlined, FileSyncOutlined, SyncOutlined } from "@ant-design/icons";
import { cloneDeep } from "lodash";
import { MAKI_IGD } from "constants/";
import { FUTO_IGD } from "constants/";
import { NIGIRI_IGD } from "constants/";
import { CALI_IGD } from "constants/";
import { XL_IGD } from "constants/";
import TableSushiIngredient from "./components/TableSushiIngredient";
import { formatCurrency, getUser } from "utils/index";
import shopApi from "api/shop";
import { BOWL_IGD, DESERTS_BOX, MAIN_BOX, RUECK_BOX, SNACKS_BOX, SUMMER_ROLL_IGD, WRAP_IGD, roles } from "constants/index";
import * as XLSX from 'xlsx';
import { toast } from "react-toastify";
import ModalImport from "./components/ModalImport";
import moment from "moment";
import TableOrderBox from "./components/TableOrderBox";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { rolesGetAllShop, rolesManualSync, rolesNotEdit } from "./roles";

const cx = classNames.bind(style);

export default function ComputeSushi() {
  const [api, contextHolder] = notification.useNotification();

  const { t } = useTranslation()

  const [formImport] = Form.useForm();

  const [listBox, setListBox] = useState([]);
  const [listSushiMaster, setListSushiMaster] = useState([]);
  const [dataSource, setDataSource] = useState([])
  const [selectedWeek, setSelectedWeek] = useState(2)
  const [selectedDay, setSelectedDay] = useState(1)
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedRenderBox, setSelectedRenderBox] = useState(['shop'])
  const [onlyVegetarianBox, setOnlyVegetarianBox] = useState(0)
  const [onlyVegetarian, setOnlyVegetarian] = useState(0)
  const [selectedShop, setSelectedShop] = useState(null)
  const [shops, setShops] = useState([])
  const [openImport, setOpenImport] = useState(false)
  const [isFixed, setIsFixed] = useState(false);
  const [showOrderBox, setShowOrderBox] = useState(false);
  const [listBoxOrder, setListBoxOrder] = useState([])

  const listBoxTableMaster = [
    { type: MAKI_BOX, name: t('maki') },
    { type: CALI_BOX, name: t('cali') },
    { type: FUTO_BOX, name: t('futo') },
    { type: NIGIRI_BOX, name: t('nigiri') },
    { type: SM_BOX, name: t('small') },
    { type: MD_BOX, name: t('medium') },
    { type: LG_BOX, name: t('large') },
    { type: ORDER_BOX, name: t('order') },
    { type: MAIN_BOX, name: t('main') },
    { type: SNACKS_BOX, name: t('snacks') },
    { type: DESERTS_BOX, name: t('deserts') },
    { type: RUECK_BOX, name: t('rueck') },
  ]

  const listIngredientMaster = [
    { type: MAKI_IGD, name: t('maki'), title: 'Maki' },
    { type: FUTO_IGD, name: t('futo'), title: 'Futo' },
    { type: NIGIRI_IGD, name: t('nigiri'), title: 'Nigiri' },
    { type: CALI_IGD, name: t('cali'), title: 'Cali' },
    { type: XL_IGD, name: t('xl'), title: 'XL' },
    { type: BOWL_IGD, name: t('bowl'), title: 'Bowl' },
    { type: WRAP_IGD, name: t('wrap'), title: 'Wrap' },
    { type: SUMMER_ROLL_IGD, name: t('summerRoll'), title: 'Sommerrolle' },
  ]

  const selectedFormatDate = useMemo(() => {
    let date;
    switch (selectedWeek) {
      case 1:
        date = moment().subtract(1, 'week').isoWeekday(selectedDay);
        break;
      case 3:
        date = moment().add(1, 'week').isoWeekday(selectedDay);
          break;
      default:
        if (selectedDay === 7) {
          date = moment().add(1, 'week').isoWeekday(1);
        } else {
          date = moment().isoWeekday(selectedDay);
        }
        
        break;
      }

      return date.format('YYYY-MM-DD');
  }, [selectedWeek, selectedDay])
  const listSushi = useMemo(() => {
    if (listSushiMaster.length === 0) return [];

    return listSushiMaster.find(item => item.productionDate === selectedFormatDate)?.boxes || []
  }, [listSushiMaster, selectedFormatDate])

  const shopCabinet = useMemo(() => {
    return selectedShop ? (shops.find(shop => shop.value == selectedShop)?.cabinet || 0) : 0
  }, [selectedShop, shops])

  const shopInfo = useMemo(() => {
    return selectedShop ? (shops.find(shop => shop.value == selectedShop) || null) : null
  }, [selectedShop, shops]);

  const totalBox = useMemo(() => dataSource
  .filter(item => item.quantity || item.quantityCabinet1 || item.quantityCabinet2)
  .reduce((cur, next) => {
    return cur +
      (selectedRenderBox.includes('shop') ? next.quantity : 0) +
      (selectedRenderBox.includes('cabinet1') ? next.quantityCabinet1 : 0) +
      (selectedRenderBox.includes('cabinet2') ? next.quantityCabinet2 : 0) +
      (selectedRenderBox.includes('boxOrder') ? next.quantityOrder : 0)
  }, 0
  ), [dataSource, selectedRenderBox]) 

  const totalSalmon = useMemo(() => dataSource.reduce(
    (cur, next) => {
      return cur +
        (selectedRenderBox.includes('shop') ? (next.quantity *
          (next.box.ingredients.reduce(
            (subCur, subNext) =>
              subCur + (subNext?.ingredient?.numSalmon || 0) * subNext.quantity, 0
          ))
        ) : 0) +
        (selectedRenderBox.includes('cabinet1') ? (next.quantityCabinet1 *
          (next.box.ingredients.reduce(
            (subCur, subNext) =>
              subCur + (subNext?.ingredient?.numSalmon || 0) * subNext.quantity, 0
          ))
        ) : 0) +
        (selectedRenderBox.includes('cabinet2') ? (next.quantityCabinet2 *
          (next.box.ingredients.reduce(
            (subCur, subNext) =>
              subCur + (subNext?.ingredient?.numSalmon || 0) * subNext.quantity, 0
          ))
        ) : 0)
    }
    , 0), [dataSource, selectedRenderBox])

  const totalTuna = useMemo(() =>  dataSource.reduce(
    (cur, next) => {
      return cur +
        (selectedRenderBox.includes('shop') ? (next.quantity *
          (next.box.ingredients.reduce(
            (subCur, subNext) =>
              subCur + (subNext?.ingredient?.numTuna || 0) * subNext.quantity, 0
          ))
        ) : 0) +
        (selectedRenderBox.includes('cabinet1') ? (next.quantityCabinet1 *
          (next.box.ingredients.reduce(
            (subCur, subNext) =>
              subCur + (subNext?.ingredient?.numTuna || 0) * subNext.quantity, 0
          ))
        ) : 0) +
        (selectedRenderBox.includes('cabinet2') ? (next.quantityCabinet2 *
          (next.box.ingredients.reduce(
            (subCur, subNext) =>
              subCur + (subNext?.ingredient?.numTuna || 0) * subNext.quantity, 0
          ))
        ) : 0)
    }
    , 0), [dataSource, selectedRenderBox])

  const totalBoxOrder = useMemo(() => dataSource.reduce(
    (cur, next) => {
      return cur + (selectedRenderBox.includes('boxOrder') ? next.quantityOrder : 0)
    }, 0)
  , [dataSource, selectedRenderBox])

  const totalPriceShop = useMemo(() => dataSource.reduce(
    (cur, next) => {
      return cur + (selectedRenderBox.includes('shop') ? next.quantity * next.box.price : 0)
    }, 0)
  , [dataSource, selectedRenderBox])

  const totalPriceCabinet1 = useMemo(() => dataSource.reduce(
    (cur, next) => {
      return cur + (selectedRenderBox.includes('cabinet1') ? next.quantityCabinet1 * next.box.price : 0)
    }, 0)
  , [dataSource, selectedRenderBox])

  const totalPriceCabinet2 = useMemo(() => dataSource.reduce(
    (cur, next) => {
      return cur + (selectedRenderBox.includes('cabinet2') ? next.quantityCabinet2 * next.box.price : 0)
    }, 0)
  , [dataSource, selectedRenderBox])

  const totalPriceBoxOrder = useMemo(() => dataSource.reduce(
    (cur, next) => {
      return cur + (selectedRenderBox.includes('boxOrder') ? next.quantityOrder * next.box.price : 0)
    }, 0)
  , [dataSource, selectedRenderBox])

  const totalAllPrice = useMemo(
    () => totalPriceShop + totalPriceCabinet1 + totalPriceCabinet2 + totalPriceBoxOrder
  , [totalPriceShop, totalPriceCabinet1, totalPriceCabinet2, totalPriceBoxOrder])

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({ message, description });
  };

  const weekTabs = [
    {
      key: 1,
      label: t('lastWeek'),
      disabled: editMode
    },
    {
      key: 2,
      label: t('thisWeek'),
      disabled: editMode
    },
    {
      key: 3,
      label: t('nextWeek'),
      disabled: editMode
    },
  ];

  const dayTabs = useMemo(() => {
    let day;
    switch (selectedWeek) {
      case 1:
        day = moment().subtract(1, 'week');
        break;
      case 3:
        day = moment().add(1, 'week');
        break;
      default:
        day = moment();
        break;
    }
    const res = [
      {
        key: 1,
        label: <span>{t('Monday')} <br /> {day.day(1).format('DD/MM')}</span>,
        disabled: editMode
      },
      {
        key: 2,
        label: <span>{t('Tuesday')} <br /> {day.day(2).format('DD/MM')}</span>,
        disabled: editMode
      },
      {
        key: 3,
        label: <span>{t('Wednesday')} <br /> {day.day(3).format('DD/MM')}</span>,
        disabled: editMode
      },
      {
        key: 4,
        label: <span>{t('Thursday')} <br /> {day.day(4).format('DD/MM')}</span>,
        disabled: editMode
      },
      {
        key: 5,
        label: <span>{t('Friday')} <br /> {day.day(5).format('DD/MM')}</span>,
        disabled: editMode
      },
      {
        key: 6,
        label: <span>{t('Saturday')} <br /> {day.day(6).format('DD/MM')}</span>,
        disabled: editMode
      },
    ]
    if (selectedWeek === 2) {
      res.push({
        key: 7,
        label: <span>{t('Monday')} <br /> {day.add(1, 'week').day(1).format('DD/MM')}</span>,
        disabled: editMode
      })
    }
    return res
  }, [selectedWeek, editMode, t])

  const optionsBoxSelect = [
    { label: t('shop'), value: 'shop' },
    { label: shopInfo?.cabinet_code_1 ? shopInfo?.cabinet_code_1 : t('cabinet', { value: 1 }), value: 'cabinet1', disabled: shopCabinet === 0 },
    { label: shopInfo?.cabinet_code_2 ? shopInfo?.cabinet_code_2 : t('cabinet', { value: 2 }), value: 'cabinet2', disabled: shopCabinet < 2 },
    { label: t('boxIndividualOrder'), value: 'boxOrder' },
  ];

  const handleSave = useCallback((row) => {
    const newData = cloneDeep(dataSource);
    const index = newData.findIndex((item) => row.box._id === item.box._id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
  }, [dataSource]);

  const handleOnCell = useCallback((record, title, dataIndex, editable = false) => {
    return {
      record,
      className: record.box.isVegetarian ? cx('vegetarian') : '',
      editable,
      dataIndex,
      title,
      handleSave,
      style
    }
  }, [handleSave])

  const onChangeShop = (value) => {
    setSelectedShop(value)
  }

  const onChangeSelectedRenderBox = (value) => {
    setSelectedRenderBox(value)
  }

  const onOpenImport = () => {
    setOpenImport(true)
  }

  const closeModalImport = () => {
    setOpenImport(false)
    formImport.resetFields()
  }

  const fetchBox = async () => {
    try {
      setLoading(true)
      const res = await boxApi.getAllBox({ sort: { isVegetarian: -1 } });
      setListBox(res.box || [])
    } catch (error) {
      console.log("🚀 ~ error:", error)
    } finally {
      setLoading(false)
    }
  }

  const fetchSushi = async () => {
    try {
      setLoading(true)
      const res = await sushiApi.getAllSushi({ dow: selectedDay, shop: selectedShop });
      setListSushiMaster(res.sushi?.boxes || [])
    } catch (error) {
      console.log("🚀 ~ error:", error)
    } finally {
      setLoading(false)
    }
  }

  const fetchSushi2 = async () => {
    try {
      setLoading(true)
      const res = await sushiApi.getAllSushi2({ shop: selectedShop });
      setListSushiMaster(res.sushi?.map(item => ({
        ...item,
        productionDate: moment(item.productionDate).format('YYYY-MM-DD'),
      })) || [])
    } catch (error) {
      console.log("🚀 ~ error:", error)
    } finally {
      setLoading(false)
    }
  }

  const fetchBoxOrder = async () => {
    try {
        setLoading(true)
        const res = await sushiApi.getBoxOrder({
          deliveryAt: selectedFormatDate,
          shop: selectedShop
        });
        setListBoxOrder(res?.orderBox || [])
    } catch (error) {
        console.log("🚀 ~ error:", error)
    } finally {
        setLoading(false)
    }
}

  const syncSushi = async () => {
    try {
      setLoading(true)
      await sushiApi.syncSushi();
      openNotificationWithIcon("success", t('notification'), t('success'));
      fetchSushi2()
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
    } finally {
      setLoading(false)
    }
  }

  const syncBoxOrder = async () => {
    try {
      setLoading(true)
      await sushiApi.syncOrderBox();
      openNotificationWithIcon("success", t('notification'), t('success'));
      selectedShop && fetchBoxOrder()
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
    } finally {
      setLoading(false)
    }
  }

  const onChangeDayTab = (value) => {
    setSelectedDay(value)
  }

  const onChangeWeekTab = (value) => {
    setSelectedWeek(value)
  }

  const toggleModeEdit = () => {
    setEditMode(true)
  }

  const saveEdit = async () => {
    try {
      setLoading(true)
      const body = {
        boxes: dataSource.map(item => ({
          quantityShop: item.quantity,
          quantityCabinet1: item.quantityCabinet1,
          quantityCabinet2: item.quantityCabinet2,
          box: item.box._id,
        })),
        productionDate: selectedFormatDate,
        shop: selectedShop,
      }
      await sushiApi.createSushi(body)
      openNotificationWithIcon("success", t('notification'), t('success'));
      fetchSushi()
      setEditMode(false)
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
    } finally {
      setLoading(false)
    }
  }

  const handleSyncData = () => {
    if (listBox.length > 0) {
      setDataSource(listBox.map(box => ({
        quantity: listSushi?.find?.(sushi => sushi?.box?._id === box?._id)?.quantityShop || 0,
        quantityCabinet1: listSushi?.find?.(sushi => sushi?.box?._id === box?._id)?.quantityCabinet1 || 0,
        quantityCabinet2: listSushi?.find?.(sushi => sushi?.box?._id === box?._id)?.quantityCabinet2 || 0,
        quantityOrder: listBoxOrder
            ?.filter(item => item.boxes.map(boxOrder => boxOrder.box.name).includes(box.name))
            ?.map(item => item.boxes.find(boxOrder => boxOrder.box.name === box.name)?.quantity || 0)
            ?.reduce((cur, next) => cur + next, 0) || 0,
          box,
      })))
    }
  }

  const cancelEdit = () => {
    setEditMode(false)
    handleSyncData()
  }

  const onChangeVegetarian = (e) => {
    setOnlyVegetarian(e.target.value)
  }

  const onChangeVegetarianBox = (e) => {
    setOnlyVegetarianBox(e.target.value)
  }

  const getStore = async () => {
    try {
      const res = await shopApi.getShopByRole();
      if (rolesGetAllShop.includes(+getUser()?.role)) {
        setShops(
          res.shops.map((shop) => ({
            value: shop.shopId,
            label: shop.shopName,
            cabinet: shop.cabinet,
            cabinet_code_1: shop.cabinet_code_1,
            cabinet_code_2: shop.cabinet_code_2,
          }))
        );
      } else {
        setShops(
          res.shops.map((shop) => ({
            value: shop.shop._id,
            label: shop.shop.name,
            cabinet: shop.shop.cabinet,
            cabinet_code_1: shop.shop.cabinet_code_1,
            cabinet_code_2: shop.shop.cabinet_code_2,
          }))
        );
      }
    } catch (error) {

    }
  };

  const onImport = async (values) => {
    try {
      const reader = new FileReader();
      const rABS = !!reader.readAsBinaryString;
      setLoading(true)
      reader.onload = async (e) => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        if (Array.isArray(data) && data.length >= 4) {
          let payload = []
          let error = ''
          data.filter(item => item.length > 0 && item).forEach((item, idx) => {
            if (idx >= 2) {
              if (shopCabinet === 0) {
                const [
                  nameMaki,
                  quantityMaki,
                  nameCali,
                  quantityCali,
                  nameFuto,
                  quantityFuto,
                  nameNigiri,
                  quantityNigiri,
                  nameSmall,
                  quantitySmall,
                  nameMedium,
                  quantityMedium,
                  nameLarge,
                  quantityLarge,
                  nameOrder,
                  quantityOrder,
                  nameMain,
                  quantityMain,
                  nameSnacks,
                  quantitySnacks,
                  nameDeserts,
                  quantityDeserts,
                  nameRueck,
                  quantityRueck,
                ] = item

                const boxMaki = listBox.find(box => box.name === nameMaki && box.type === MAKI_BOX)
                const boxCali = listBox.find(box => box.name === nameCali && box.type === CALI_BOX)
                const boxFuto = listBox.find(box => box.name === nameFuto && box.type === FUTO_BOX)
                const boxNigiri = listBox.find(box => box.name === nameNigiri && box.type === NIGIRI_BOX)
                const boxSmall = listBox.find(box => box.name === nameSmall && box.type === SM_BOX)
                const boxMedium = listBox.find(box => box.name === nameMedium && box.type === MD_BOX)
                const boxLarge = listBox.find(box => box.name === nameLarge && box.type === LG_BOX)
                const boxOrder = listBox.find(box => box.name === nameOrder && box.type === ORDER_BOX)
                const boxMain = listBox.find(box => box.name === nameMain && box.type === MAIN_BOX)
                const boxSnacks = listBox.find(box => box.name === nameSnacks && box.type === SNACKS_BOX)
                const boxDeserts = listBox.find(box => box.name === nameDeserts && box.type === DESERTS_BOX)
                const boxRueck = listBox.find(box => box.name === nameRueck && box.type === RUECK_BOX)

                boxMaki && payload.push({
                  quantityShop: quantityMaki,
                  quantityCabinet1: 0,
                  quantityCabinet2: 0,
                  box: boxMaki._id,
                })
                boxCali && payload.push({
                  quantityShop: quantityCali,
                  quantityCabinet1: 0,
                  quantityCabinet2: 0,
                  box: boxCali._id,
                })
                boxFuto && payload.push({
                  quantityShop: quantityFuto,
                  quantityCabinet1: 0,
                  quantityCabinet2: 0,
                  box: boxFuto._id,
                })
                boxNigiri && payload.push({
                  quantityShop: quantityNigiri,
                  quantityCabinet1: 0,
                  quantityCabinet2: 0,
                  box: boxNigiri._id,
                })
                boxSmall && payload.push({
                  quantityShop: quantitySmall,
                  quantityCabinet1: 0,
                  quantityCabinet2: 0,
                  box: boxSmall._id,
                })
                boxMedium && payload.push({
                  quantityShop: quantityMedium,
                  quantityCabinet1: 0,
                  quantityCabinet2: 0,
                  box: boxMedium._id,
                })
                boxLarge && payload.push({
                  quantityShop: quantityLarge,
                  quantityCabinet1: 0,
                  quantityCabinet2: 0,
                  box: boxLarge._id,
                })
                boxOrder && payload.push({
                  quantityShop: quantityOrder,
                  quantityCabinet1: 0,
                  quantityCabinet2: 0,
                  box: boxOrder._id,
                })
                boxMain && payload.push({
                  quantityShop: quantityMain,
                  quantityCabinet1: 0,
                  quantityCabinet2: 0,
                  box: boxMain._id,
                })
                boxSnacks && payload.push({
                  quantityShop: quantitySnacks,
                  quantityCabinet1: 0,
                  quantityCabinet2: 0,
                  box: boxSnacks._id,
                })
                boxDeserts && payload.push({
                  quantityShop: quantityDeserts,
                  quantityCabinet1: 0,
                  quantityCabinet2: 0,
                  box: boxDeserts._id,
                })
                boxRueck && payload.push({
                  quantityShop: quantityRueck,
                  quantityCabinet1: 0,
                  quantityCabinet2: 0,
                  box: boxRueck._id,
                })
              } else if (shopCabinet > 1) {
                const [
                  nameMaki,
                  quantityMaki,
                  quantityCabinet1Maki,
                  quantityCabinet2Maki,
                  nameCali,
                  quantityCali,
                  quantityCabinet1Cali,
                  quantityCabinet2Cali,
                  nameFuto,
                  quantityFuto,
                  quantityCabinet1Futo,
                  quantityCabinet2Futo,
                  nameNigiri,
                  quantityNigiri,
                  quantityCabinet1Nigiri,
                  quantityCabinet2Nigiri,
                  nameSmall,
                  quantitySmall,
                  quantityCabinet1Small,
                  quantityCabinet2Small,
                  nameMedium,
                  quantityMedium,
                  quantityCabinet1Medium,
                  quantityCabinet2Medium,
                  nameLarge,
                  quantityLarge,
                  quantityCabinet1Large,
                  quantityCabinet2Large,
                  nameOrder,
                  quantityOrder,
                  quantityCabinet1Order,
                  quantityCabinet2Order,
                  nameMain,
                  quantityMain,
                  quantityCabinet1Main,
                  quantityCabinet2Main,
                  nameSnacks,
                  quantitySnacks,
                  quantityCabinet1Snacks,
                  quantityCabinet2Snacks,
                  nameDeserts,
                  quantityDeserts,
                  quantityCabinet1Deserts,
                  quantityCabinet2Deserts,
                  nameRueck,
                  quantityRueck,
                  quantityCabinet1Rueck,
                  quantityCabinet2Rueck,
                ] = item

                const boxMaki = listBox.find(box => box.name === nameMaki && box.type === MAKI_BOX)
                const boxCali = listBox.find(box => box.name === nameCali && box.type === CALI_BOX)
                const boxFuto = listBox.find(box => box.name === nameFuto && box.type === FUTO_BOX)
                const boxNigiri = listBox.find(box => box.name === nameNigiri && box.type === NIGIRI_BOX)
                const boxSmall = listBox.find(box => box.name === nameSmall && box.type === SM_BOX)
                const boxMedium = listBox.find(box => box.name === nameMedium && box.type === MD_BOX)
                const boxLarge = listBox.find(box => box.name === nameLarge && box.type === LG_BOX)
                const boxOrder = listBox.find(box => box.name === nameOrder && box.type === ORDER_BOX)
                const boxMain = listBox.find(box => box.name === nameMain && box.type === MAIN_BOX)
                const boxSnacks = listBox.find(box => box.name === nameSnacks && box.type === SNACKS_BOX)
                const boxDeserts = listBox.find(box => box.name === nameDeserts && box.type === DESERTS_BOX)
                const boxRueck = listBox.find(box => box.name === nameRueck && box.type === RUECK_BOX)

                boxMaki && payload.push({
                  quantityShop: quantityMaki,
                  quantityCabinet1: quantityCabinet1Maki,
                  quantityCabinet2: quantityCabinet2Maki,
                  box: boxMaki._id,
                })
                boxCali && payload.push({
                  quantityShop: quantityCali,
                  quantityCabinet1: quantityCabinet1Cali,
                  quantityCabinet2: quantityCabinet2Cali,
                  box: boxCali._id,
                })
                boxFuto && payload.push({
                  quantityShop: quantityFuto,
                  quantityCabinet1: quantityCabinet1Futo,
                  quantityCabinet2: quantityCabinet2Futo,
                  box: boxFuto._id,
                })
                boxNigiri && payload.push({
                  quantityShop: quantityNigiri,
                  quantityCabinet1: quantityCabinet1Nigiri,
                  quantityCabinet2: quantityCabinet2Nigiri,
                  box: boxNigiri._id,
                })
                boxSmall && payload.push({
                  quantityShop: quantitySmall,
                  quantityCabinet1: quantityCabinet1Small,
                  quantityCabinet2: quantityCabinet2Small,
                  box: boxSmall._id,
                })
                boxMedium && payload.push({
                  quantityShop: quantityMedium,
                  quantityCabinet1: quantityCabinet1Medium,
                  quantityCabinet2: quantityCabinet2Medium,
                  box: boxMedium._id,
                })
                boxLarge && payload.push({
                  quantityShop: quantityLarge,
                  quantityCabinet1: quantityCabinet1Large,
                  quantityCabinet2: quantityCabinet2Large,
                  box: boxLarge._id,
                })
                boxOrder && payload.push({
                  quantityShop: quantityOrder,
                  quantityCabinet1: quantityCabinet1Order,
                  quantityCabinet2: quantityCabinet2Order,
                  box: boxOrder._id,
                })
                boxMain && payload.push({
                  quantityShop: quantityMain,
                  quantityCabinet1: quantityCabinet1Main,
                  quantityCabinet2: quantityCabinet2Main,
                  box: boxMain._id,
                })
                boxSnacks && payload.push({
                  quantityShop: quantitySnacks,
                  quantityCabinet1: quantityCabinet1Snacks,
                  quantityCabinet2: quantityCabinet2Snacks,
                  box: boxSnacks._id,
                })
                boxDeserts && payload.push({
                  quantityShop: quantityDeserts,
                  quantityCabinet1: quantityCabinet1Deserts,
                  quantityCabinet2: quantityCabinet2Deserts,
                  box: boxDeserts._id,
                })
                boxRueck && payload.push({
                  quantityShop: quantityRueck,
                  quantityCabinet1: quantityCabinet1Rueck,
                  quantityCabinet2: quantityCabinet2Rueck,
                  box: boxRueck._id,
                })
              } else if (shopCabinet > 0) {
                const [
                  nameMaki,
                  quantityMaki,
                  quantityCabinet1Maki,
                  nameCali,
                  quantityCali,
                  quantityCabinet1Cali,
                  nameFuto,
                  quantityFuto,
                  quantityCabinet1Futo,
                  nameNigiri,
                  quantityNigiri,
                  quantityCabinet1Nigiri,
                  nameSmall,
                  quantitySmall,
                  quantityCabinet1Small,
                  nameMedium,
                  quantityMedium,
                  quantityCabinet1Medium,
                  nameLarge,
                  quantityLarge,
                  quantityCabinet1Large,
                  nameOrder,
                  quantityOrder,
                  quantityCabinet1Order,
                  nameMain,
                  quantityMain,
                  quantityCabinet1Main,
                  nameSnacks,
                  quantitySnacks,
                  quantityCabinet1Snacks,
                  nameDeserts,
                  quantityDeserts,
                  quantityCabinet1Deserts,
                  nameRueck,
                  quantityRueck,
                  quantityCabinet1Rueck,
                ] = item

                const boxMaki = listBox.find(box => box.name === nameMaki && box.type === MAKI_BOX)
                const boxCali = listBox.find(box => box.name === nameCali && box.type === CALI_BOX)
                const boxFuto = listBox.find(box => box.name === nameFuto && box.type === FUTO_BOX)
                const boxNigiri = listBox.find(box => box.name === nameNigiri && box.type === NIGIRI_BOX)
                const boxSmall = listBox.find(box => box.name === nameSmall && box.type === SM_BOX)
                const boxMedium = listBox.find(box => box.name === nameMedium && box.type === MD_BOX)
                const boxLarge = listBox.find(box => box.name === nameLarge && box.type === LG_BOX)
                const boxOrder = listBox.find(box => box.name === nameOrder && box.type === ORDER_BOX)
                const boxMain = listBox.find(box => box.name === nameMain && box.type === MAIN_BOX)
                const boxSnacks = listBox.find(box => box.name === nameSnacks && box.type === SNACKS_BOX)
                const boxDeserts = listBox.find(box => box.name === nameDeserts && box.type === DESERTS_BOX)
                const boxRueck = listBox.find(box => box.name === nameRueck && box.type === RUECK_BOX)

                boxMaki && payload.push({
                  quantityShop: quantityMaki,
                  quantityCabinet1: quantityCabinet1Maki,
                  quantityCabinet2: 0,
                  box: boxMaki._id,
                })
                boxCali && payload.push({
                  quantityShop: quantityCali,
                  quantityCabinet1: quantityCabinet1Cali,
                  quantityCabinet2: 0,
                  box: boxCali._id,
                })
                boxFuto && payload.push({
                  quantityShop: quantityFuto,
                  quantityCabinet1: quantityCabinet1Futo,
                  quantityCabinet2: 0,
                  box: boxFuto._id,
                })
                boxNigiri && payload.push({
                  quantityShop: quantityNigiri,
                  quantityCabinet1: quantityCabinet1Nigiri,
                  quantityCabinet2: 0,
                  box: boxNigiri._id,
                })
                boxSmall && payload.push({
                  quantityShop: quantitySmall,
                  quantityCabinet1: quantityCabinet1Small,
                  quantityCabinet2: 0,
                  box: boxSmall._id,
                })
                boxMedium && payload.push({
                  quantityShop: quantityMedium,
                  quantityCabinet1: quantityCabinet1Medium,
                  quantityCabinet2: 0,
                  box: boxMedium._id,
                })
                boxLarge && payload.push({
                  quantityShop: quantityLarge,
                  quantityCabinet1: quantityCabinet1Large,
                  quantityCabinet2: 0,
                  box: boxLarge._id,
                })
                boxOrder && payload.push({
                  quantityShop: quantityOrder,
                  quantityCabinet1: quantityCabinet1Order,
                  quantityCabinet2: 0,
                  box: boxOrder._id,
                })
                boxMain && payload.push({
                  quantityShop: quantityMain,
                  quantityCabinet1: quantityCabinet1Main,
                  quantityCabinet2: 0,
                  box: boxMain._id,
                })
                boxSnacks && payload.push({
                  quantityShop: quantitySnacks,
                  quantityCabinet1: quantityCabinet1Snacks,
                  quantityCabinet2: 0,
                  box: boxSnacks._id,
                })
                boxDeserts && payload.push({
                  quantityShop: quantityDeserts,
                  quantityCabinet1: quantityCabinet1Deserts,
                  quantityCabinet2: 0,
                  box: boxDeserts._id,
                })
                boxRueck && payload.push({
                  quantityShop: quantityRueck,
                  quantityCabinet1: quantityCabinet1Rueck,
                  quantityCabinet2: 0,
                  box: boxRueck._id,
                })
              }
            }
          })
          if (!error) {
            try {
              const body = {
                boxes: payload,
                productionDate: selectedFormatDate,
                shop: selectedShop,
              }
              await sushiApi.createSushi(body)

              openNotificationWithIcon("success", t('notification'), t('importSuccess'));
              fetchSushi()
              closeModalImport()
            } catch (error) {
              openNotificationWithIcon("error", t('error'), t('hasError'));
            } finally {
              setLoading(false)
            }
          } else {
            openNotificationWithIcon("error", t('error'), error || t('hasError'));
          }

        } else toast.error("Import error!")

        /* Update state */
      };
      if (rABS) reader.readAsBinaryString(values.upload[0].originFileObj);
      else reader.readAsArrayBuffer(values.upload[0].originFileObj);
    } catch (error) {
      // toast.error(error?.response?.data || ERROR_OCCUR)
    } finally {
    }
  }

  const onExportIngredient = async () => {
    const PAGE_WIDTH = 59.944;
    const PAGE_HEIGHT = 199.644;
    const doc = new jsPDF({
      orientation: 'p',      // Dọc
      unit: 'mm',            // Đơn vị mm
      format: [PAGE_WIDTH, PAGE_HEIGHT],    // Kích thước tùy chỉnh: width 300mm, height 150mm
    });

    listIngredientMaster.map((item, index) => {
      // Lấy bảng HTML từ DOM
      // Sử dụng autotable để tự động tạo bảng từ DOM hoặc từ dữ liệu
      doc.setFontSize(12)
      doc.text(item.title, 2, 6);
      doc.autoTable({
          html: '#' + item.title, // ID của bảng HTML
          startY: 9,        // Vị trí bắt đầu của bảng
          margin: { left: 2 },
          theme: 'grid',
          tableWidth: PAGE_WIDTH - 4,
          styles: {
            lineWidth: 0.01,
            lineColor: '#000',
          },
          tableLineWidth: 0.01,
          tableLineColor: '#000',
      });
      if (index < listIngredientMaster.length - 1) {
        doc.addPage();
      }
    })

    doc.save(`${selectedFormatDate}.pdf`);
  }

  useEffect(() => {
    selectedShop && handleSyncData()
  }, [listBox, listSushi, listBoxOrder])

  useEffect(() => {
    fetchBox()
    getStore()
  }, [])

  useEffect(() => {
    if (selectedShop) {
      // fetchSushi()
      fetchSushi2()
    }
  }, [selectedShop])


  useEffect(() => {
    selectedShop && fetchBoxOrder()
}, [selectedFormatDate, selectedShop])

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 800) { // Adjust this value as needed
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    setSelectedDay(1)
  }, [selectedWeek])

  useEffect(() => {
    setShowOrderBox(listBoxOrder.length > 0)
  }, [listBoxOrder])

  return (
    <div className={cx("page-sushi")}>
      {contextHolder}
      <div className={cx("title")}>
        <p>{t('computeSushi')}</p>
      </div>
      {
        rolesManualSync.includes(+getUser().role) &&
        <>
          <Space>
            <Button loading={loading} onClick={syncSushi} size="large" icon={<SyncOutlined />}>{t('manualSyncSushi')}</Button>
            <Button
            type="primary"
              loading={loading}
              icon={<SyncOutlined />} 
              size="large"
              onClick={syncBoxOrder}
            >
                {t('manualSyncBoxOrder')}
            </Button>
          </Space>
          <Divider />
        </>
      }
      <p>{t('shop')}</p>
      <Row>
        <Col span={4}>
          <Select
            options={shops}
            disabled={editMode}
            allowClear
            value={selectedShop}
            style={{ width: '100%' }}
            onChange={onChangeShop} />
        </Col>
      </Row>
      {
        selectedShop &&
       <>
         <Tabs
          activeKey={selectedWeek}
          onChange={onChangeWeekTab}
          centered
          type="card"
          items={weekTabs}
        />
         <Tabs
          className={cx("day-tabs")}
          activeKey={selectedDay}
          onChange={onChangeDayTab}
          centered
          items={dayTabs}
        />
       </>
      }
      <Divider />
      {
        selectedShop && 
        <Button
          icon={showOrderBox ? <EyeInvisibleOutlined /> : <EyeOutlined />} 
          size="large"
          onClick={() => setShowOrderBox(!showOrderBox)}
        >
            {t('boxIndividualOrder')}
        </Button>
      }
      { 
        selectedShop && showOrderBox && 
        <TableOrderBox
          loading={loading}
          listBoxOrder={listBoxOrder}
        />
      }
      <Divider />
      {
        selectedShop &&
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {
            !editMode &&
            !rolesNotEdit.includes(+getUser().role) &&
              <Button loading={loading} icon={<EditOutlined />} type='primary' size='large' onClick={toggleModeEdit}>{t('edit')}</Button>
          }
          {
            editMode &&
              <Space>
                <Button loading={loading} icon={<FileSyncOutlined />} type='primary' size='large' onClick={saveEdit}>{t('save')}</Button>
                <Button loading={loading} icon={<CloseOutlined />} danger size='large' onClick={cancelEdit}>{t('cancel')}</Button>
              </Space>
          }
          <Button loading={loading} icon={<ExportOutlined />} size='large' onClick={onExportIngredient}>{t('exportIngredient')}</Button>
        </div>
      }
      <Divider />
      <ModalImport loading={loading} show={openImport} onFinish={onImport} form={formImport} onCancel={closeModalImport} />
      <>
        {
          selectedShop &&
          <>
            <Card title={<div style={{ textAlign: 'center', fontSize: 26 }}>{t('box')}</div>} className={cx('card')}>
              <Space className={cx("select-area", { fixed: isFixed })}>
                <Checkbox.Group value={selectedRenderBox} options={optionsBoxSelect} onChange={onChangeSelectedRenderBox} />
                <Radio.Group value={onlyVegetarianBox} onChange={onChangeVegetarianBox}>
                  <Radio value={0}>{t("all")}</Radio>
                  <Radio value={1}>{t("vegetarian")}</Radio>
                </Radio.Group>
              </Space>
              <Row gutter={[32]}>
                {
                  listBoxTableMaster.map((item, index) => (
                    <Col key={index} span={12}>
                      <Divider>{item.name}</Divider>
                      <TableSushiBox
                        data={dataSource}
                        renderQuantity={selectedRenderBox}
                        shopInfo={shopInfo}
                        onlyVegetarian={onlyVegetarianBox}
                        handleOnCell={handleOnCell}
                        editMode={editMode}
                        loading={loading}
                        type={item.type} />
                    </Col>
                  ))
                }
              </Row>
            </Card>
            <Divider />
            <Card className={cx('summary')}>
              <Descriptions bordered column={1}>
                <Descriptions.Item label={t('totalQuantityBox')}>
                  {totalBox}
                </Descriptions.Item>
                <Descriptions.Item label={t('totalQuantitySalmon')}>
                  {totalSalmon}
                </Descriptions.Item>
                <Descriptions.Item label={t('totalQuantityTuna')}>
                  {totalTuna}
                </Descriptions.Item>
                <Descriptions.Item label={t('totalQuantityBoxOrder')}>
                  {totalBoxOrder}
                </Descriptions.Item>
                <Descriptions.Item label={t('shop')}>
                  {formatCurrency(totalPriceShop)}
                </Descriptions.Item>
                <Descriptions.Item label={t('cabinet', { value: 1 })}>
                  {formatCurrency(totalPriceCabinet1)}
                </Descriptions.Item>
                <Descriptions.Item label={t('cabinet', { value: 2 })}>
                  {formatCurrency(totalPriceCabinet2)}
                </Descriptions.Item>
                <Descriptions.Item label={t('boxIndividualOrder')}>
                  {formatCurrency(totalPriceBoxOrder)}
                </Descriptions.Item>
                <Descriptions.Item label={t('sumPrice')}>
                  {formatCurrency(totalAllPrice)}
                </Descriptions.Item>
              </Descriptions>
            </Card>
            <Divider />
            <Card title={<div style={{ textAlign: 'center', fontSize: 26 }}>{t('ingredient')}</div>} className={cx('card')}>
              <Row gutter={[32]}>
                {
                  listIngredientMaster.map((item, index) => (
                    <Col key={index} span={12}>
                      <Divider>{item.name}</Divider>
                      <TableSushiIngredient
                        data={dataSource}
                        cabinet={shopCabinet}
                        renderQuantity={selectedRenderBox}
                        onlyVegetarian={onlyVegetarian}
                        loading={loading}
                        type={item.type}
                        name={item.title}
                      />
                    </Col>
                  ))
                }
              </Row>
            </Card>
          </>
        }
      </>
    </div>
  );
}
